import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ProveedorDistribuidorContent } from './components/ProveedorDistribuidorContent';

export default function ProveedorDistribuidorCreation() {
    return (
        <MainContent
            component={<ProveedorDistribuidorContent />}
            titulo='Proveedor Distribucion'
        />
    );

};
